<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">{{ dicts.page_title[dicts.lang] }}</h4>
					<button class="float-right btn btn-primary shadow"
					        v-on:click="formInvoiceItemActive=!formInvoiceItemActive">
						{{ dicts.button_add_invoice[dicts.lang] }}
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formInvoiceItemActive">
						<div class="row p-3 mx-2 bg-white shadow">
							<div class="col-12 mb-3">
								<h4 class="my-0 py-0">{{ dicts.tittle_form[dicts.lang] }}</h4>
								<hr>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.so[dicts.lang] }}</label>
								<smart-search init url="/api/pemesanan/seeker/order"
								              v-on:update="(data)=>smartSearchOrderNumber(data)" key-tag="all"
								              :label-tag="['order_number']" :addon="{used:'no'}"
								              v-on:clear="(res)=>{clearData()}" :search-value="newsodatalabel"
								              @update-direct="(label)=>newsodatalabel=label"></smart-search>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.no_invoice[dicts.lang] }}</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newInvoiceItem.invoice_no" required/>
							</div>
							<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							  <label class="d-block">Status</label>
							  <smart-select name="status" :options="statusTypeOptions" v-on:update="updateNewIiStatus"></smart-select>
							</div> -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.invoice_date[dicts.lang] }}</label>
								<b-form-datepicker today-button reset-button close-button locale="id"
								                   :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
								                   id="datepicker-invoice-date" v-model="newInvoiceItem.invoice_date"
								                   class="mb-2">{{ newInvoiceItem.invoice_date }}
								</b-form-datepicker>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.invoice_due_date[dicts.lang] }}</label>
								<b-form-datepicker today-button reset-button close-button locale="id"
								                   :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
								                   id="datepicker-due-date" v-model="newInvoiceItem.due_date"
								                   class="mb-2">{{ newInvoiceItem.due_date }}
								</b-form-datepicker>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2" v-if="false">
								<label class="d-block">Proforma</label>
								<smart-select name="proforma" :options="proformaTypeOptions"
								              v-on:update="updateNewIiProforma"></smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">QR Code</label>
								<smart-select name="qr_code" :options="proformaQrCodeOptions"
								              v-on:update="updateNewQrCode"></smart-select>
							</div>
							<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							  <label class="d-block">{{dicts.start_date[dicts.lang]}}</label>
							  <b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-start-date-activation" v-model="newInvoiceItem.active_date_setup" class="mb-2">{{newInvoiceItem.active_date_setup}}</b-form-datepicker>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
							  <label class="d-block">{{dicts.due_date[dicts.lang]}}</label>
							  <b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-end-date-activation" v-model="newInvoiceItem.due_date_setup" class="mb-2">{{newInvoiceItem.due_date_setup}}</b-form-datepicker>
							</div>-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.hardware_price[dicts.lang] }}</label>
								<smart-search init url="/api/master/seeker/hardware-price" key-tag="name_hardware_price"
								              v-on:update="(data)=>smartSearchHardwarePrice(data)"
								              :search-value="newhardwarepricelabel" :label-tag="['name_hardware_price']"
								              @update-direct="(label)=>newhardwarepricelabel=label"
								              @input="calculateAmount"></smart-search>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Airtime</label>
								<smart-select name="airtime" :options="airtimeTypeOptions"
								              v-on:update="updateNewIiAirtime"></smart-select>
							</div>
							<!-- <div class="col-12 col-md-6 col-lg-4 mt-2" v-if="isNewAirtime">
								<label class="d-block">{{dicts.airtime_price[dicts.lang]}}</label>
								<smart-search direct url="/api/master/seeker/airtime-price" key-tag="name_airtime_price" v-on:update="(data)=>smartSearchAirtimePrice(data)" :search-value="newairtimepricelabel" @update-direct="(label)=>newairtimepricelabel=label" @input="calculateAmount"></smart-search>
							</div> -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.discount[dicts.lang] }}</label>
								<smart-search init url="/api/master/seeker/discount" key-tag="discount"
								              @clear="smartSearchDiscount(null)"
								              v-on:update="(data)=>smartSearchDiscount(data)"
								              :search-value="newdiscountlabel"
								              @update-direct="(label)=>newdiscountlabel=label"></smart-search>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.ppn[dicts.lang] }}</label>
								<smart-select name="ppn" :options="ppnTypeOptions"
								              v-on:update="updateNewPpn"></smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">PIC</label>
								<input type="text" class="form-control w-100 rounded" v-model="newInvoiceItem.cp"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2 mb-2">
								<label class="d-block">{{ dicts.position[dicts.lang] }}</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newInvoiceItem.department"/>
							</div>
		                    <div class="col-12 col-md-6 col-lg-4 mt-2">
		                      <label class="d-block">Account Bank</label>
			                    <smart-search 
			                    :search-value="newInvoiceItem.label_bank" init url="/api/master/seeker/bank" usedefault :default-value="newInvoiceItem.label_bank" key-tag="nama" v-on:update="(data)=>{newInvoiceItem.id_bank=data.id}"  @update-direct="(label)=>newInvoiceItem.label_bank=label"></smart-search>
		                    </div>
							<div class="col-12 mt-2 rounded" style="border:1px solid #dee2e6 !important;">
								<h4 class="font-weight-bold">Detail invoice</h4>
								<hr>
								<div class="row" v-if="selectedMetaToCreate.length>0">
									<div class="col-4 my-1">
										<h5 class="mt-0 mb-3 bg-success text-light rounded pl-2 py-1">
											{{ dicts.choice_vessel[dicts.lang] }}</h5>
									</div>
								</div>
								<div class="row mt-1" v-if="selectedMetaToCreate.length>0">
									<div class="col-12">
										<div class="row px-2">
											<div class=" py-2 px-3 col-12 col-md-4"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.vessel[dicts.lang] }} </b></small></div>
											<!-- <div class=" py-2 px-3 col-12 col-md-2"  style="border:1px solid #dee2e6 !important;"><small><b>Hardware </b></small></div>  -->
											<div class=" py-2 px-3 col-12 col-md-2"
											     style="border:1px solid #dee2e6 !important;"><small><b>ID
												transmitter: </b></small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.no_sn[dicts.lang] }}: </b></small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.no_jb[dicts.lang] }}: </b></small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.price[dicts.lang] }} (IDR)</b></small></div>
										</div>
									</div>
								</div>
								<div class="row" v-for="(data,index) in selectedMetaToCreate" v-bind:key="'newSO'+data"
								     @click="dismissFromInvoice(index)">
									<div class="col-12">
										<div class="row px-2">
											<div class=" py-2 px-3 col-12 col-md-4"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{ data.vessel.name }} </small></div>
											<!-- <div class=" py-2 px-3 col-12 col-md-2"  style="border:1px solid #dee2e6 !important;"><small>{{data.vessel.name}} </small></div>  -->
											<div class=" py-2 px-3 col-12 col-md-2"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{ data.hardware_setup.id_transmitter }}</small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small>
													{{
														data.hardware_setup.serial_number != null ? data.hardware_setup.serial_number.serial_number : "-"
													}}<br>
													{{
														data.hardware_setup.serial_number != null ? data.hardware_setup.serial_number.purchase_order_metadata.hardware.hardware_name : "-"
													}}<br>
												</small>
											</div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small>
													{{
														data.hardware_setup.jb != null ? data.hardware_setup.jb.serial_number : "-"
													}}<br>
													{{
														data.hardware_setup.jb != null ? data.hardware_setup.jb.purchase_order_metadata.hardware.hardware_name : "-"
													}}<br>
												</small>
											</div>
											<div class="col-12 col-md-2  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{
														newInvoiceItem.price_hardware ? newInvoiceItem.price_hardware : 0 | numeral(
															"0,0")
													}}</small>
											</div>
											<div class="col-12 col-md-4  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;"
											     v-if="newInvoiceItem.airtime=='yes'&&newAirtimePrice.name_airtime_price!=undefined">
												{{ newAirtimePrice.name_airtime_price }}
											</div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;"
											     v-if="newInvoiceItem.airtime=='yes'&&newAirtimePrice.name_airtime_price!=undefined">
												-
											</div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;"
											     v-if="newInvoiceItem.airtime=='yes'&&newAirtimePrice.name_airtime_price!=undefined">
												-
											</div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;"
											     v-if="newInvoiceItem.airtime=='yes'&&newAirtimePrice.name_airtime_price!=undefined">
												-
											</div>
											<div class="col-12 col-md-2  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;"
											     v-if="newInvoiceItem.airtime=='yes'&&newAirtimePrice.price!=undefined">
												<small>{{
														newAirtimePrice.price ? newAirtimePrice.price : 0 | numeral(
															"0,0")
													}}</small>
											</div>


										</div>
									</div>
								</div>
								<div class="row mt-1" v-if=" selectedMetaToCreate.length>0">
									<div class="col-12">
										<div class="row px-2">
											<div class="col-12 col-md-10  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.discount_capital[dicts.lang] }}</b></small></div>
											<div class="col-12 col-md-2  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ newInvoiceItem.discount > 0 ? "-" : "" }}{{
														newInvoiceItem.discount | numeral("0,0")
													}}</b></small></div>
										</div>
									</div>
								</div>
								<div class="row mt-1" v-if=" selectedMetaToCreate.length>0">
									<div class="col-12">
										<div class="row px-2">
											<div class="col-12 col-md-10  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>SUBTOTAL</b></small></div>
											<div class="col-12 col-md-2  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ newInvoiceItem.subtotal | numeral("0,0") }}</b></small>
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-1" v-if=" selectedMetaToCreate.length>0">
									<div class="col-12">
										<div class="row px-2">
											<div class="col-12 col-md-10  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.ppn[dicts.lang] }}</b></small></div>
											<div class="col-12 col-md-2  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;"><small><b>{{
													newInvoiceItem.ppn == "yes" ? (newInvoiceItem.subtotal * selectedMetaToCreate.length) * (this.base_ppn/100) : "0" | numeral(
														"0,0")
												}} </b></small></div>
										</div>
									</div>
								</div>
								<div class="row mt-1" v-if=" selectedMetaToCreate.length>0">
									<div class="col-12">
										<div class="row px-2">
											<div class="col-12 col-md-10  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>TOTAL</b></small></div>
											<div class="col-12 col-md-2  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;"><small><b>{{
													this.newInvoiceItem.total | numeral("0,0")
												}}</b></small></div>
										</div>
									</div>
								</div>
								<div class="row" v-if="selectedMetaToCreate.length<1">
									<div class="col-5 my-1">
										<h5 class="mt-0 mb-3 bg-danger text-light rounded pl-2 py-1">
											{{ dicts.selected_vessel[dicts.lang] }}</h5>
									</div>
								</div>
							</div>
							<div class="col-12 mt-2 rounded" style="border:1px solid #dee2e6 !important;"
							     v-if="dataToCreate.metadata!=undefined">
								<h4 class="font-weight-bold">{{ dicts.item[dicts.lang] }}</h4>
								<hr>
								<div class="row mt-1" v-if=" dataToCreate.metadata.length>0">
									<div class="col-12">
										<div class="row px-2">
											<div class=" py-2 px-3 col-12 col-md-4"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.vessel[dicts.lang] }} </b></small></div>
											<div class=" py-2 px-3 col-12 col-md-2"
											     style="border:1px solid #dee2e6 !important;"><small><b>ID
												transmitter: </b></small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.no_sn[dicts.lang] }}: </b></small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.no_jb[dicts.lang] }}: </b></small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.price[dicts.lang] }} (IDR)</b></small></div>
										</div>
									</div>
								</div>
								<div class="row" v-for="(data,index) in dataToCreate.metadata"
								     v-bind:key="'newReadySO'+data" @click="addToInvoice(index)">
									<div class="col-12">
										<div class="row px-2">
											<div class=" py-2 px-3 col-12 col-md-4"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{ data.vessel.name }} </small></div>
											<div class=" py-2 px-3 col-12 col-md-2"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{ data.hardware_setup.id_transmitter }}</small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{
														data.hardware_setup.serial_number != null ? data.hardware_setup.serial_number.serial_number : "-"
													}}</small>
											</div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{
														data.hardware_setup.jb != null ? data.hardware_setup.jb.serial_number : "-"
													}}</small>
											</div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;"><small>Rp -</small></div>


										</div>
									</div>
								</div>

								<div class="row" v-if="dataToCreate.metadata.length<1">
									<div class="col-12 my-1">
										<h5 class="mt-0 mb-3">{{ dicts.nothing[dicts.lang] }}</h5>
									</div>
								</div>
							</div>


							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="newInvoiceItemSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Invoice Perangkat Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorNewInvoiceItem">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">Gagal Menyimpan Invoice Perangkat Baru.</p>
										</div>
										<div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start"
								     v-if="savingNewInvoiceItem">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button"
								        v-on:click="saveNewInvoiceItem">{{ dicts.submit[dicts.lang] }}
								</button>
							</div>
						</div>
					</div>
				</transition>


				<div class="col-12  my-2 py-0">
					<datatable :currentIdx="currentPage" :lang="dicts.lang" :datas="invoiceitems"
					           :structure="invoiceitemTableStructure" :init="loadData"
					           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
					           use-filter use-seeker seeker-url="/api/pemesanan/seeker/invoice"
					           use-xml xml-url="/api/xml/invoice"
					           @refetch="(row)=>{rowLimit=row;getInvoiceItems()}"
					           @searching="(val)=>!val.status?getInvoiceItems():invoiceitems=val.data">
						<template #customcell={obj,index} class="w-100">
							<td>{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td style="width:200px;">{{ obj.invoice_no }}</td>
							<td>{{ obj.client != null ? obj.client.legal_name : "-" }}</td>
							<td>{{ obj.client != null ? obj.client.npwp : "-" }}</td>
							<td>{{ obj.invoice_date | timeformat }}</td>
							<td>
								<b-button v-if="obj.invoice_metadata[0].order_metadata.hardware_setup!=undefined
                      && obj.invoice_metadata[0].order_metadata.hardware_setup.date_active!=undefined
                      && obj.invoice_metadata[0].order_metadata.hardware_setup.date_active !=null
                      && obj.invoice_metadata[0].order_metadata.hardware_setup.serial_number!=null
                      && obj.invoice_metadata[0].order_metadata.hardware_setup.serial_number.device!=null"
								          v-b-modal.modal-sap class="btn btn-success"
								          :href="'https://api-billing.megahsurya.com/api/invoice/sap/'+obj.invoice_metadata[0].order_metadata.hardware_setup.id">
									<b>SAP</b></b-button>
							</td>
							<td>
								<b-button class="btn btn-warning mr-2 mb-1"
								          :href="'https://api-billing.megahsurya.com/api/invoice/item/'+obj.id+'?qr=yes'"
								          title="Invoice">
									<b-icon icon="printer"></b-icon>
								</b-button>
								<b-button class="btn btn-secondary mr-2 mb-1"
								          :href="'https://api-billing.megahsurya.com/api/invoice/item/'+obj.id+'?proforma=yes&qr=yes'"
								          title="Proforma invoice">
									<b-icon icon="printer"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-detail-histories class="btn btn-success mr-2 mb-1"
								          v-on:click="getHistories(obj.id)" title="History">
									<b-icon icon="clock-history"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-detail-invoice class="btn btn-primary mr-2 mb-1"
								          v-on:click="selectedDetail=index">
									<b-icon icon="eye" title="View"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-edit-invoice class="btn btn-info mb-1 mr-2"
								          v-on:click="editPreparation(index)"
								          v-if="['master_admin','admin'].includes(role)" title="Edit">
									<b-icon icon="pencil-square"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"
								          class="btn btn-danger mr-2 mb-1"
								          v-if="['master_admin','admin'].includes(role)" title="Delete">
									<b-icon icon="trash"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>

				<b-modal id="modal-edit-invoice" title="Edit data" scrollable no-close-on-backdrop size="lg"
				         @hide="editModalClose" v-if="invoiceitems.length>0">
					<div class="row" v-if="invoiceitems[selectedIdforEdit]!=undefined">
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.so[dicts.lang] }}</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceitems[selectedIdforEdit].sales_order != undefined && invoiceitems[selectedIdforEdit].sales_order != null ? invoiceitems[selectedIdforEdit].sales_order.order_number : "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.no_invoice[dicts.lang] }}</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="invoiceitems[selectedIdforEdit].invoice_no"/>
						</div>
						<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Status</label>
							<smart-select name="status" :options="statusTypeOptions" usedefault :default-value="invoiceitems[selectedIdforEdit].status" v-on:update="(value)=>{invoiceitems[selectedIdforEdit].status=value}"></smart-select>
						</div> -->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.invoice_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button locale="id"
							                   :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
							                   id="datepicker-invoice-date"
							                   v-model="invoiceitems[selectedIdforEdit].invoice_date" class="mb-2">
								{{ invoiceitems[selectedIdforEdit].invoice_date }}
							</b-form-datepicker>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.invoice_due_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button locale="id"
							                   :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
							                   id="datepicker-due-date"
							                   v-model="invoiceitems[selectedIdforEdit].due_date" class="mb-2">
								{{ invoiceitems[selectedIdforEdit].due_date }}
							</b-form-datepicker>
						</div>
						<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Proforma</label>
							<smart-select name="proforma" :options="proformaTypeOptions" usedefault :default-value="invoiceitems[selectedIdforEdit].proforma" v-on:update="(value)=>{invoiceitems[selectedIdforEdit].proforma=value}"></smart-select>
						</div> -->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.start_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button locale="id"
							                   :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
							                   id="datepicker-update-start-date-activation"
							                   @input="(e)=>{invoiceitems[selectedIdforEdit].active_date_setup=e}"
							                   :value="invoiceitems[selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_active"
							                   class="mb-2"></b-form-datepicker>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.due_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button locale="id"
							                   :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
							                   id="datepicker-update-end-date-activation"
							                   @input="(e)=>{invoiceitems[selectedIdforEdit].due_date_setup=e}"
							                   v-model="invoiceitems[selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_due"
							                   class="mb-2">{{ invoiceitems[selectedIdforEdit].due_date_setup }}
							</b-form-datepicker>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.hardware_price[dicts.lang] }}</label>
							<smart-search init url="/api/master/seeker/hardware-price" usedefault
							              :default-value="invoiceitems[selectedIdforEdit].hardware_price.name_hardware_price"
							              @clear="smartSearchUpdateHardwarePrice(null)" key-tag="name_hardware_price"
							              v-on:update="(data)=>smartSearchUpdateHardwarePrice(data)"></smart-search>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.airtime_price[dicts.lang] }}</label>
							<smart-search init url="/api/master/seeker/airtime-price" usedefault
							              :default-value="invoiceitems[selectedIdforEdit].name_airtime_price"
							              @clear="smartSearchUpdateAirtimePrice(null)" key-tag="name_airtime_price"
							              v-on:update="(data)=>smartSearchUpdateAirtimePrice(data)"></smart-search>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.discount[dicts.lang] }}</label>
							<smart-search init url="/api/master/seeker/discount" usedefault
							              :default-value="invoiceitems[selectedIdforEdit].discount_detail!=undefined&&invoiceitems[selectedIdforEdit].discount_detail.discount"
							              key-tag="discount" @clear="smartSearchUpdateDiscount(null)"
							              v-on:update="(data)=>smartSearchUpdateDiscount(data)"></smart-search>
						</div>

						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Total {{ dicts.discount[dicts.lang] }}</label>
							<div class="form-control w-100 rounded">
								{{ invoiceitems[selectedIdforEdit].discount | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Sub Total</label>
							<div class="form-control w-100 rounded">
								{{ invoiceitems[selectedIdforEdit].subtotal | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.ppn[dicts.lang] }}</label>
							<smart-select name="ppn" :options="ppnTypeOptions"
							              v-on:update="(value)=>{invoiceitems[selectedIdforEdit].ppn=value;$forceUpdate();calculateUpdateAmount()}"></smart-select>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Total</label>
							<div class="form-control w-100 rounded">
								{{ invoiceitems[selectedIdforEdit].total | numeral("0,0") }}
							</div>
						</div>
						<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Airtime</label>
							<smart-select name="airtime" :options="airtimeTypeOptions" v-on:update="(value)=>{invoiceitems[selectedIdforEdit].airtime=value}"></smart-select>
						</div> -->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">PIC</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="invoiceitems[selectedIdforEdit].cp"/>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.position[dicts.lang] }}</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="invoiceitems[selectedIdforEdit].department"/>
						</div>

	                    <div class="col-12 col-md-6 col-lg-4 mt-2">
	                      <label class="d-block">Account Bank</label>
	                      <smart-search 
	                      :search-value="newInvoiceItem.label_bank" init url="/api/master/seeker/bank" usedefault :default-value="invoiceitems[selectedIdforEdit].bank == null ? '' : invoiceitems[selectedIdforEdit].bank.nama" key-tag="nama" v-on:update="(data)=>{invoiceitems[selectedIdforEdit].id_bank=data.id}"  @update-direct="(label)=>newInvoiceItem.label_bank=label"></smart-search>
	                    </div>

						<div class="col-12 mt-3">
							<div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
								<div class="alert alert-success" role="alert">
									Berhasil Update Data Invoice Perangkat.
								</div>
							</div>
						</div>
					</div>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1 text-left">Gagal update Invoice Perangkat.</p>
										</div>
										<div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="updating">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-info float-right" type="button" v-on:click="updateInvoiceItem">
									{{ dicts.submit[dicts.lang] }}
								</button>
								<b-button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-edit-invoice')">
									{{ dicts.close[dicts.lang] }}
								</b-button>
							</div>
						</div>
					</template>
				</b-modal>

				<b-modal no-close-on-esc content-class="m-0" id="modal-detail-histories" size="lg"
				         title="Detail history" scrollable no-close-on-backdrop>
					<datatable no-toolbar responsive :datas="histories" :structure="historyTableStructure"
					           :init="loadHistoriesData" use-seeker seeker-url="/api/report/json/invoice-item-history"
					           @searching="(val)=>!val.status?getHistories():histories=val.data">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Nama admin:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												obj.editor != null ? obj.editor.name : "-"
											}}</b>
										</div>
										<hr class="my-1">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Tanggal perubahan:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												JSON.parse(obj.old_data).created_at | timeformat
											}}</b>
										</div>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Nomor invoice:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ JSON.parse(obj.old_data).invoice_no }}</b>
										</div>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Tanggal invoice:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												JSON.parse(obj.old_data).invoice_date | timeformat
											}}</b>
										</div>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Tanggal invoice jatuh tempo:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												JSON.parse(obj.old_data).due_date | timeformat
											}}</b>
										</div>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Jabatan:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ JSON.parse(obj.old_data).cp }}</b>
										</div>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">PIC:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ JSON.parse(obj.old_data).department }}</b>
										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.editor != null ? obj.editor.name : "-" }}</td>
							<td v-if="!isMobile">{{ JSON.parse(obj.old_data).created_at | timeformat }}</td>
							<td v-if="!isMobile">{{ JSON.parse(obj.old_data).invoice_no }}</td>
							<td v-if="!isMobile">{{ JSON.parse(obj.old_data).invoice_date | timeformat }}</td>
							<td v-if="!isMobile">{{ JSON.parse(obj.old_data).due_date | timeformat }}</td>
							<td v-if="!isMobile">{{ JSON.parse(obj.old_data).cp }}</td>
							<td v-if="!isMobile">{{ JSON.parse(obj.old_data).department }}</td>
						</template>
					</datatable>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary"
							          @click="(!deleteState)?$bvModal.hide('modal-detail-histories'):''">Close
							</b-button>
						</div>
					</template>
				</b-modal>

				<b-modal no-close-on-esc content-class="m-0" size="lg" title="Detail Invoice" id="modal-detail-invoice"
				         scrollable no-close-on-backdrop @hide="detailModalClose">
					<b-container fluid v-if="!loadData&&invoiceitems.length>0">
						<b-row class="pt-1" v-if="invoiceitems[selectedDetail]!=undefined">
							<b-col cols="12">
								<table v-if="invoiceitems.length>0" rules="rows" class="table w-100"
								       style="overflow-x:auto;">
									<tbody>
									<tr>
										<th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt"
										    colspan="2" scope="row">Detail Invoice
										</th>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.so[dicts.lang] }}</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].sales_order != undefined && invoiceitems[selectedDetail].sales_order != null ? invoiceitems[selectedDetail].sales_order.order_number : "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.no_invoice[dicts.lang] }}</th>
										<td class="">{{ invoiceitems[selectedDetail].invoice_no }}</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.no_sn[dicts.lang] }}</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].invoice_metadata[0] != undefined && invoiceitems[selectedDetail].invoice_metadata[0].order_metadata.hardware_setup.serial_number != null ? invoiceitems[selectedDetail].invoice_metadata[0].order_metadata.hardware_setup.serial_number.serial_number : "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">ID transmitter</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].invoice_metadata[0] != undefined && invoiceitems[selectedDetail].invoice_metadata[0] != null ? invoiceitems[selectedDetail].invoice_metadata[0].order_metadata.hardware_setup.id_transmitter : "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.no_jb[dicts.lang] }}</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].invoice_metadata[0] != undefined && invoiceitems[selectedDetail].invoice_metadata[0].order_metadata.hardware_setup.jb != null ? invoiceitems[selectedDetail].invoice_metadata[0].order_metadata.hardware_setup.jb.serial_number : "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.vessel[dicts.lang] }}</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].invoice_metadata[0] != undefined && invoiceitems[selectedDetail].invoice_metadata[0].order_metadata.hardware_setup.vessel != null ? invoiceitems[selectedDetail].invoice_metadata[0].order_metadata.hardware_setup.vessel.name : "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.client[dicts.lang] }}</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].client != undefined && invoiceitems[selectedDetail].client != null ? invoiceitems[selectedDetail].client.legal_name : "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.npwp[dicts.lang] }}</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].client != undefined && invoiceitems[selectedDetail].client != null ? invoiceitems[selectedDetail].client.npwp : "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.invoice_date[dicts.lang] }}</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].invoice_date ? invoiceitems[selectedDetail].invoice_date : "-" | timeformat
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.invoice_due_date[dicts.lang] }}</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].due_date ? invoiceitems[selectedDetail].due_date : "-" | timeformat
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.hardware_price[dicts.lang] }}</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].hardware_price ? invoiceitems[selectedDetail].hardware_price.name_hardware_price : "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.hardware_price[dicts.lang] }} (IDR)</th>
										<td class="">Rp {{
												invoiceitems[selectedDetail].price_hardware ? invoiceitems[selectedDetail].price_hardware : "-" | numeral(
													"0,0")
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.airtime_price[dicts.lang] }}</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].hardware_price ? invoiceitems[selectedDetail].hardware_price.name_hardware_price : "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.airtime_price[dicts.lang] }} (IDR)</th>
										<td class="">Rp {{
												invoiceitems[selectedDetail].price_hardware ? invoiceitems[selectedDetail].price_airtime : "-" | numeral(
													"0,0")
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">Subtotal</th>
										<td class="">Rp {{
												invoiceitems[selectedDetail].subtotal ? invoiceitems[selectedDetail].subtotal : "-" | numeral(
													"0,0")
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.ppn[dicts.lang] }}</th>
										<td class="">{{ translatePPN(invoiceitems[selectedDetail].ppn) }}</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.discount[dicts.lang] }}</th>
										<td class="">Rp {{
												invoiceitems[selectedDetail].discount ? invoiceitems[selectedDetail].discount : "-" | numeral(
													"0,0")
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">Total</th>
										<td class="">Rp {{
												invoiceitems[selectedDetail].total ? invoiceitems[selectedDetail].total : "-" | numeral(
													"0,0")
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">Airtime</th>
										<td class="">{{ translateAirtime(invoiceitems[selectedDetail].airtime) }}</td>
									</tr>
									<tr>
										<th class="" scope="row">PIC</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].cp ? invoiceitems[selectedDetail].cp : "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.position[dicts.lang] }}</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].department ? invoiceitems[selectedDetail].department : "-"
											}}
										</td>
									</tr>
									</tbody>
								</table>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary"
							          @click="(!deleteUserState)?$bvModal.hide('modal-detail-invoice'):''">
								{{ dicts.close[dicts.lang] }}
							</b-button>
						</div>
					</template>
				</b-modal>

			</div>
		</div>
		<modal-delete url="/api/pemesanan/invoice/" @read="()=>{console.log('modal ready')}" @result="deleteResult"
		              :targetid="deleteId">
			{{ dicts.desc_delete[dicts.lang] }}:<br>
			<ul>
				<li>{{ dicts.no_invoice[dicts.lang] }}: {{ itemToDelete.invoice_no }}</li>
			</ul>
		</modal-delete>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import {EventBus} from "../../eventbus";
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import SmartSearch from "../../components/SmartSearch.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"smart-search": SmartSearch,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			base_ppn: 11,
			currentPage: 1,
			perPage: null,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			selectedHistories: 0,
			role: "",
			isNewAirtime: false,
			dataEdit: null,//step 1 edit
			selectedDetail: 0,
			newsodatalabel: "",
			isMobile: false,
			currentdiscountlabel: "",
			newairtimepricelabel: "",
			newhardwarepricelabel: "",
			newdiscountlabel: "",
			newBanklabel: "",
			itemToDelete: {},
			invoiceitems: [],
			histories: [],
			searchValue: "",
			loadData: true,
			loadHistoriesData: true,
			savingNewInvoiceItem: false,
			errorNewInvoiceItem: false,
			errorInvoiceItemList: [],
			existingClientResult: [],
			newInvoiceItemSaved: false,
			selectedTab: 0,
			newHardwarePrice: 0,
			updateHardwarePrice: 0,
			updateAirtimePrice: 0,
			newAirtimePrice: {},
			newDiscount: {},
			updateDiscount: {},
			selectedIdforEdit: 0,
			updateSaved: false,
			errorUpdate: false,
			updating: false,
			deleteId: 0,
			// deleteTargetId:0,
			dataToCreate: [],
			selectedMetaToCreate: [],
			cache: {
				editItem: {}
			},
			newInvoiceItem: {
				invoice_no: "",
				invoice_date: "",
				client_id: "",
				totalPPN: 0,
				new_order_metadata_id: [],
				due_date: "",
				npwp: "",
				proforma: "no",
				airtime: "yes",
				order_number_id: "",
				hardware_name_id: "",
				vessel_id: "",
				telephone: "",
				email: "",
				serial_number_id: "",
				idtransmitter_id: "",
				jb_invoice: "",
				price_hardware: "",
				price_airtime: "",
				discount: 0,
				discount_id: "",
				id_bank: "",
				label_bank: "",
				price_hardware_id: "",
				subtotal: 0,
				ppn: "yes",
				total: 0,
				status: "Actual",
				cp: "",
				department: ""
			},
			formInvoiceItemActive: false,
			historyTableStructure: [
				{label: "No", key: null},
				{
					label: {
						id: "Nama admin",
						en: "Admin name"
					},
					key: null
				},
				{
					label: {
						id: "Tanggal perubahan",
						en: "Updated at"
					},
					key: null
				},
				{
					label: {
						id: "Nomor invoice",
						en: "Invoice number"
					},
					key: null
				},
				{
					label: {
						id: "Tanggal invoice",
						en: "Invoice date"
					},
					key: null
				},
				{
					label: {
						id: "Tanggal invoice jatuh tempo",
						en: "Invoice due date"
					},
					key: null
				},
				{
					label: {
						id: "Jabatan",
						en: "Position"
					},
					key: null
				},
				{
					label: {
						id: "PIC",
						en: "PIC"
					},
					key: null
				}
			],
			invoiceitemTableStructure: [
				//label: nama heading, key: nama object property
				{label: "No", key: null},
				{
					label: {
						id: "Nomor Invoice",
						en: "Invoice number"
					},
					key: null
				},
				{
					label: {
						id: "Pelanggan",
						en: "Client"
					},
					key: null
				},
				{
					label: {
						id: "NPWP",
						en: "Tax number"
					},
					key: null
				},
				{
					label: {
						id: "Tanggal Invoice",
						en: "Invoice date"
					},
					key: null
				},
				{label: "SAP", key: null},
				{
					label: {
						id: "Tindakan",
						en: "Action"
					},
					key: null
				}
			],
			dicts: {
				lang: "id",
				page_title: {
					id: "Invoice perangkat",
					en: "Invoice item"
				},
				button_add_invoice: {
					id: "Tambah invoice baru",
					en: "Add new invoice"
				},
				tittle_form: {
					id: "Form invoice perangkat",
					en: "New invoice item form"
				},
				so: {
					id: "Nomor SO",
					en: "SO number"
				},
				no_invoice: {
					id: "Nomor invoice",
					en: "Invoice number"
				},
				invoice_date: {
					id: "Tanggal invoice",
					en: "Invoice date"
				},
				invoice_due_date: {
					id: "Tanggal invoice jatuh tempo",
					en: "Invoice due date"
				},
				hardware_price: {
					id: "Harga perangkat",
					en: "Hardware price"
				},
				airtime_price: {
					id: "Harga airtime",
					en: "Airtime price"
				},
				discount: {
					id: "Diskon",
					en: "Discount"
				},
				position: {
					id: "Jabatan",
					en: "Position"
				},
				choice_vessel: {
					id: "Kapal terpilih untuk membuat invoice",
					en: "The vessel selected to create the invoice"
				},
				vessel: {
					id: "Nama kapal",
					en: "Vessel name"
				},
				no_sn: {
					id: "Nomor SN",
					en: "SN number"
				},
				no_jb: {
					id: "Nomor JB",
					en: "JB number"
				},
				price: {
					id: "Harga",
					en: "Price"
				},
				discount_capital: {
					id: "DISKON",
					en: "DISCOUNT"
				},
				selected_vessel: {
					id: "Pilih item tersedia untuk membuat invoice",
					en: "Select an available item to create an invoice"
				},
				item: {
					id: "Item tersedia",
					en: "Item available"
				},
				nothing: {
					id: "Tidak ada detail tersedia",
					en: "No details available"
				},
				submit: {
					id: "Simpan",
					en: "Submit"
				},
				close: {
					id: "Tutup",
					en: "Close"
				},
				client: {
					id: "Pelanggan",
					en: "Client"
				},
				npwp: {
					id: "NPWP",
					en: "Tax number"
				},
				desc_delete: {
					id: "Yakin mau menghapus data dengan detail berikut",
					en: "You are sure you want to delete data with the following details"
				},
				ppn: {
					id: "PPN",
					en: "Tax"
				},
				start_date: {
					id: "Tanggal aktivasi",
					en: "Activation date"
				},
				due_date: {
					id: "Jatuh tempo",
					en: "Due date"
				}
			},
			proformaTypeOptions: [
				{label: "Tidak", value: "no"},
				{label: "Ya", value: "yes"}
			],
			proformaQrCodeOptions: [
				{label: "Tidak", value: "no"},
				{label: "Ya", value: "yes"}
			],
			statusTypeOptions: [
				{label: "Actual", value: "Actual"},
				{label: "Temporary", value: "Temporary"}
			],
			ppnTypeOptions: [
				{label: "Ya", value: "yes"},
				{label: "Tidak", value: "no"}
			],
			airtimeTypeOptions: [
				{label: "Tidak", value: "no"},
				{label: "Ya", value: "yes"}
			]
		};
	},
	created() {
		this.role = localStorage.getItem("role");
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		this.getInvoiceItems();
		this.getHistories();
		this.dicts.lang = localStorage.getItem("lang");
		EventBus.$on("lang", () => {
			console.log("changing invoice item lang");
			this.dicts.lang = localStorage.getItem("lang");
		});
		// var newData = [];
		// for(var x=0;x<100;x++){
		//     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
		// }
		// console.log(newData);
		// this.users = newData;
		this.getSetPpn();
	},
	methods: {
		// getSetPpn(){
		// 	axios.get(this.$baseUrl + "/api/setting?key=ppn", {
		// 		"headers": {
		// 			"Authorization": "Bearer " + localStorage.getItem("accessToken")
		// 		}
		// 	}).then((result) => {
		// 		console.log(result);
		// 		this.base_ppn = result.data.value;
	    //         result.data.forEach((data)=>{
	    //         	this.ppnTypeOptions.push({label:data.value+' %',value:data.value})
	    //         })
		// 		console.log(this.base_ppn);
		// 	}).catch((err) => {
		// 		check if token fail
		// 	});
		// },
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = myParams;
			var newUrl = this.$baseUrl + "/api/pemesanan/invoice?limit=" + this.rowLimit + "&page=" + myParams;
			this.getInvoiceItems(newUrl);
		},
		editPreparation(index) {
			console.log("index for edit: " + index);
			this.selectedIdforEdit = index;
			console.log(this.invoiceitems[index]);
			this.cache.editItem = Object.assign({}, this.invoiceitems[index]);
			console.log(this.cache.editItem);
			console.log("edit journey start here");
		},
		translatePPN(ppn) {
			var label = "";
			switch (ppn) {
				case "yes":
					label = "Ya";
					break;
				case "no":
					label = "Tidak";
					break;
			}
			return label;
		},
		translateProforma(proforma) {
			var label = "";
			switch (proforma) {
				case "yes":
					label = "Ya";
					break;
				case "no":
					label = "Tidak";
					break;
			}
			return label;
		},
		translateAirtime(airtime) {
			var label = "";
			switch (airtime) {
				case "yes":
					label = "Ya";
					break;
				case "no":
					label = "Tidak";
					break;
			}
			return label;
		},
		editModalClose(mdl) {
			console.log(this.cache.editItem);
			this.$set(this.invoiceitems, this.selectedIdforEdit, Object.assign({}, this.cache.editItem));
			this.cache.editItem = Object.assign({}, {});
			console.log(this.invoiceitems[this.selectedIdforEdit]);
			this.$forceUpdate();
			//this.$set(this.invoiceitems,this.selectedIdforEdit,this.dataEdit) //step 2 edit
			//this.dataEdit = Object.assign({},null)//step 3 edit
			if (this.updating) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				//mdl.hide('modal-edit-invoice');
			}
		},
		detailModalClose(mdl) {
			if (this.updating) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-detail-invoice");
			}
		},
		dismissFromInvoice(index) {
			this.dataToCreate.metadata.push(this.selectedMetaToCreate[index]);
			this.newInvoiceItem.new_order_metadata_id.splice(index, 1);
			this.selectedMetaToCreate.splice(index, 1);
			this.$forceUpdate();
			this.calculateAmount();
		},
		addToInvoice(index) {
			console.log(index);
			console.log(this.dataToCreate);
			this.newInvoiceItem.new_order_metadata_id.push(this.dataToCreate.metadata[index].id);
			this.selectedMetaToCreate.push(this.dataToCreate.metadata[index]);
			this.dataToCreate.metadata.splice(index, 1);
			this.$forceUpdate();
			this.calculateAmount();
		},
		getInvoiceItemsPDF() {
			this.loadData = true;
			axios.get(this.$baseUrl + "https://api-billing.megahsurya.com/api/invoiceitem-pdf/item/" + id, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.invoiceitems = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		getHistories(id) {
			var url = this.$baseUrl + "/api/report/json/invoice-item-history/" + id;
			this.loadHistoriesData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.histories = result.data;
				this.loadHistoriesData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadHistoriesData = false;
			});
		},
		getInvoiceItems(url = (this.$baseUrl + "/api/pemesanan/invoice?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.invoiceitems = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},

		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getInvoiceItems();
			}
		},
		// getDeleteUrl(){
		//   return '/api/pemesanan/invoice/'+this.deleteTargetId;
		// },
		// deleteItem(item){
		//     this.deleteTargetId = item.id
		// },
		calculateAmount() {
			this.newInvoiceItem.subtotal = parseInt(this.newInvoiceItem.price_hardware) * parseInt(this.selectedMetaToCreate.length);

			var airtimeTotal = 0;
			var subtotalNonAirtime = this.newInvoiceItem.subtotal;
			if (this.newInvoiceItem.airtime == "yes" && this.newAirtimePrice.price != undefined) {
				console.log("calculate with airtime");
				airtimeTotal = (parseInt(this.newAirtimePrice.price) * parseInt(this.selectedMetaToCreate.length));

			}

			this.newInvoiceItem.subtotal = parseInt(this.newInvoiceItem.subtotal) + airtimeTotal;

			if (this.newDiscount.discount_type != undefined && this.newDiscount.discount_type != "nominal") {
				this.newInvoiceItem.discount = subtotalNonAirtime * this.newDiscount.price / 100;
			}
			var discountedSubtotal = parseInt(this.newInvoiceItem.subtotal) - parseInt(this.newInvoiceItem.discount);

			this.newInvoiceItem.subtotal = discountedSubtotal;


			// this.newInvoiceItem.total = discountedSubtotal +((this.newInvoiceItem.ppn != "no") ? discountedSubtotal * (this.newInvoiceItem.ppn/100) : 0);
			this.newInvoiceItem.total = discountedSubtotal +((this.newInvoiceItem.ppn == "yes") ? discountedSubtotal * (this.base_ppn/100) : 0);
			this.newInvoiceItem.total = Math.round((this.newInvoiceItem.total / 10)) * 10;

			//this.newInvoiceItem.total=this.newInvoiceItem.price_hardware * this.selectedMetaToCreate.length + (this.newInvoiceItem.ppn=="yes"? (this.newInvoiceItem.price_hardware * this.selectedMetaToCreate.length)*0.1:0) - this.newInvoiceItem.discount


			// if(this.newAirtimePrice>0 && this.newHardwarePrice>0){
			//     this.newInvoiceItem.subtotal = parseInt(this.newAirtimePrice) + parseInt(this.newHardwarePrice) - this.newDiscount;
			//     if(this.newInvoiceItem.ppn=="yes"){
			//         this.newInvoiceItem.total = this.newInvoiceItem.subtotal - (this.newInvoiceItem.subtotal * 0.1)
			//         this.newInvoiceItem.totalPPN =  this.newInvoiceItem.subtotal * 0.1
			//         console.log(this.totalPPN)
			//     }else{
			//       this.newInvoiceItem.total = this.newInvoiceItem.subtotal;
			//         this.newInvoiceItem.totalPPN = 0
			//     }
			// }else{
			//     this.newInvoiceItem.subtotal=0
			// }
		},
		calculateUpdateAmount() {
			var totalMetadata = this.invoiceitems[this.selectedIdforEdit].invoice_metadata.length;
			console.clear();
			console.log("total item: " + totalMetadata);
			console.log("price item: " + this.invoiceitems[this.selectedIdforEdit].price_hardware);
			console.log("price airtime: " + this.invoiceitems[this.selectedIdforEdit].price_airtime);

			this.invoiceitems[this.selectedIdforEdit].subtotal = this.invoiceitems[this.selectedIdforEdit].price_hardware * totalMetadata;

			console.log("subtotal: " + this.invoiceitems[this.selectedIdforEdit].subtotal);

			if (this.updateAirtimePrice.price != undefined) {
				this.invoiceitems[this.selectedIdforEdit].subtotal = this.invoiceitems[this.selectedIdforEdit].subtotal + (this.invoiceitems[this.selectedIdforEdit].price_airtime * totalMetadata);
			}
			console.log("subtotal after airtime: " + this.invoiceitems[this.selectedIdforEdit].subtotal);


			if (this.updateDiscount.discount_type != undefined && this.updateDiscount.discount_type != "nominal") {
				this.invoiceitems[this.selectedIdforEdit].discount = this.invoiceitems[this.selectedIdforEdit].subtotal * this.updateDiscount.price / 100;
			}
			console.log("discount: " + this.invoiceitems[this.selectedIdforEdit].discount);

			this.invoiceitems[this.selectedIdforEdit].subtotal = this.invoiceitems[this.selectedIdforEdit].subtotal - this.invoiceitems[this.selectedIdforEdit].discount;

			console.log("discounted subtotal: " + this.invoiceitems[this.selectedIdforEdit].subtotal);
			var ppn = 0;

			// if (this.invoiceitems[this.selectedIdforEdit].ppn != "no") {
			// 	ppn = this.invoiceitems[this.selectedIdforEdit].subtotal * (this.invoiceitems[this.selectedIdforEdit].ppn_number/100);
			if (this.invoiceitems[this.selectedIdforEdit].ppn == "yes") {
				ppn = this.invoiceitems[this.selectedIdforEdit].subtotal / 10;
			console.log("ppn (" + this.invoiceitems[this.selectedIdforEdit].ppn + "): " + ppn);

			this.invoiceitems[this.selectedIdforEdit].total = this.invoiceitems[this.selectedIdforEdit].subtotal - ppn;
			console.log("total: " + this.invoiceitems[this.selectedIdforEdit].total);

			this.$forceUpdate();
			}
		},
		updateNewIiProforma(data) {
			this.newInvoiceItem.proforma = data;
		},
		updateNewQrCode(data) {
			this.newInvoiceItem.qr_code = data;
		},
		updateNewIiStatus(data) {
			this.newInvoiceItem.status = data;
		},
		updateNewPpn(data) {
			this.newInvoiceItem.ppn = data;
			this.calculateAmount();
		},
		// updateEditPPN(value){
        //   	this.invoiceitems[this.selectedIdforEdit].ppn=(value != "no" ? "yes" : "no");
        //   	this.invoiceitems[this.selectedIdforEdit].ppn_number=(value != "no" ? value : 0);
		// },
		updateNewIiAirtime(newValue) {
			this.newInvoiceItem.airtime = newValue;
			if (newValue == "yes") {
				this.isNewAirtime = true;
				this.getDefaultAirtime();
			} else {
				this.isNewAirtime = false;
			}
		},
		getDefaultAirtime() {
			axios.get(this.$baseUrl + "/api/master/airtime-price-default", {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result.data);
				this.newAirtimePrice = result.data;
				this.$forceUpdate();
				this.calculateAmount();
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		resetPostData() {
			this.newInvoiceItem = {
				invoice_no: "",
				invoice_date: "",
				client_id: "",
				totalPPN: 0,
				new_order_metadata_id: [],
				due_date: "",
				npwp: "",
				proforma: "no",
				airtime: "no",
				order_number_id: "",
				hardware_name_id: "",
				vessel_id: "",
				client_id: "",
				telephone: "",
				email: "",
				serial_number_id: "",
				idtransmitter_id: "",
				jb_invoice: "",
				price_hardware: "",
				price_airtime: "",
				discount: 0,
				discount_id: "",
				id_bank: "",
				label_bank: "",
				price_hardware_id: "",
				subtotal: 0,
				ppn: "yes",
				total: 0,
				subtotal: 0,
				status: "Actual",
				cp: "",
				department: ""
			};
			this.dataToCreate = [],
				this.selectedMetaToCreate = [];
		},
		saveNewInvoiceItem() {

			// this.calculateAmount()
			console.log(this.newInvoiceItem);
			// return
			// this.newInvoiceItem.ppn_number = (this.newInvoiceItem.ppn != "no" ? this.newInvoiceItem.ppn : 0);
			// this.newInvoiceItem.ppn = (this.newInvoiceItem.ppn != "no" ? "yes" : "no");

			this.savingNewInvoiceItem = true;
			this.errorNewInvoiceItem = false;
			if (
				this.newInvoiceItem.invoice_no != "" &&
				this.newInvoiceItem.order_number_id != "" &&
				this.newInvoiceItem.invoice_date != "" &&
				this.newInvoiceItem.price_hardware != "" &&
				this.newInvoiceItem.subtotal > 0 &&
				this.newInvoiceItem.total > 0
			) {
				// console.log(this.newInvoiceItem);
				// return false;
				axios.post(
					this.$baseUrl + "/api/pemesanan/invoice",
					this.newInvoiceItem,
					{
						"headers":
							{
								"Authorization": "Bearer " + localStorage.getItem("accessToken")
							}
					}
				).then((result) => {
					console.log(result);
					this.savingNewInvoiceItem = false;
					this.newInvoiceItemSaved = true;
					this.getInvoiceItems();
					this.resetPostData();
					setTimeout(() => {
						this.formInvoiceItemActive = false;
						this.newInvoiceItemSaved = false;
					}, 1000);
				}).catch((err) => {
					//check if token fail
					if (err.response && err.response.status == 401) {
						localStorage.removeItem("accessToken");
						this.$router.push("/login");
					}
					console.clear();
					console.log(err.response);
					this.savingNewInvoiceItem = false;
					this.errorNewInvoiceItem = true;
				});
			} else {
				console.log("data invalid");
				this.errorNewInvoiceItem = true;
			}
		},
		updateInvoiceItem() {
			this.updating = true;
			this.errorUpdate = false;
			axios.put(
				this.$baseUrl + "/api/pemesanan/invoice/" + this.invoiceitems[this.selectedIdforEdit].id,
				this.invoiceitems[this.selectedIdforEdit],
				{
					headers: {
						"Authorization": "Bearer " + localStorage.getItem("accessToken")
					}
				}
			).then((result) => {
				if (result.status = 200) {
					this.cache.editItem = this.invoiceitems[this.selectedIdforEdit];
					if (this.invoiceitems[this.selectedIdforEdit].active_date_setup != undefined) {
						this.invoiceitems[this.selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_active = this.invoiceitems[this.selectedIdforEdit].active_date_setup;
					}
					if (this.invoiceitems[this.selectedIdforEdit].due_date_setup != undefined) {
						this.invoiceitems[this.selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_due = this.invoiceitems[this.selectedIdforEdit].active_date_setup;
					}
					this.updating = false;
					this.updateSaved = true;
					//step 4 edit
					// this.dataEdit = this.invoiceitems[this.selectedIdforEdit]
					setTimeout(() => {
						this.updateSaved = false;
						this.$bvModal.hide("modal-edit-invoice");
					}, 1000);
				}
				console.log(result);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updating = false;
				this.errorUpdate = true;
				setTimeout(() => {
					this.errorUpdate = false;
				}, 1000);
				console.log(err);
			});
		},
		newUsernameChange() {
			this.newInvoiceItem.password = this.newInvoiceItem.username.toUpperCase();
		},
		deleteItem(item) {
			console.log("button delete untuk user id: " + item.id);
		},
		updateUserRoleValue(newValue) {
			this.newInvoiceItem.role = newValue;
		},
		setNewClientId(newId) {
			this.newInvoiceItem.clientId = newId;
			console.log(this.newInvoiceItem.clientId);
		},
		smartSearchOrderNumber(data) {
			this.selectedMetaToCreate = [];
			this.dataToCreate = data;
			this.newInvoiceItem.client_id = data.client_id;
			console.clear();
			console.log(data);
			this.newInvoiceItem.order_number_id = data.id;
		},
		smartSearchHardwarePrice(data) {
			this.newInvoiceItem.price_hardware = data.price;
			this.newInvoiceItem.price_hardware_id = data.id;
			this.newHardwarePrice = data;
			this.$forceUpdate();
			this.calculateAmount();
		},
		smartSearchUpdateHardwarePrice(data) {
			this.invoiceitems[this.selectedIdforEdit].price_hardware = data.price;
			this.invoiceitems[this.selectedIdforEdit].price_hardware_id = data.id;
			this.updateHardwarePrice = data;
			this.$forceUpdate();
			this.calculateUpdateAmount();
		},
		smartSearchAirtimePrice(data) {
			this.newInvoiceItem.price_airtime = data.price;
			this.newInvoiceItem.airtime_price_id = data.id;
			this.newAirtimePrice = data;
			this.$forceUpdate();
			this.calculateAmount();
		},
		smartSearchUpdateAirtimePrice(data) {
			if (data == null) {
				this.invoiceitems[this.selectedIdforEdit].price_airtime = null;
				this.invoiceitems[this.selectedIdforEdit].airtime_price_id = null;
				this.updateAirtimePrice = {};
			} else {
				this.invoiceitems[this.selectedIdforEdit].price_airtime = data.price;
				this.invoiceitems[this.selectedIdforEdit].airtime_price_id = data.id;
				this.updateAirtimePrice = data;
			}
			this.$forceUpdate();
			this.calculateUpdateAmount();
		},
		smartSearchDiscount(data) {
			if (data == null) {
				this.newInvoiceItem.discount = 0;
				this.newInvoiceItem.discount_id = "";
				this.newDiscount = {};
				this.$forceUpdate();
				return;
			}
			if (data.discount_type == "nominal") {
				this.newInvoiceItem.discount = data.price;
			}
			this.newInvoiceItem.discount_id = data.id;
			this.newDiscount = data;
			this.$forceUpdate();
			this.calculateAmount();
		},
		smartSearchUpdateDiscount(data) {
			if (data == null) {
				this.invoiceitems[this.selectedIdforEdit].discount = 0;
				this.invoiceitems[this.selectedIdforEdit].discount_id = "";
				this.updateDiscount = {};
				this.currentdiscountlabel = "";
				this.$forceUpdate();
				return;
			}
			if (data.discount_type == "nominal") {
				this.invoiceitems[this.selectedIdforEdit].discount = data.price;
			}
			this.invoiceitems[this.selectedIdforEdit].discount_id = data.id;
			this.updateDiscount = data;
			this.currentdiscountlabel = data.discount;
			this.$forceUpdate();
			this.calculateUpdateAmount();
		},
		smartSearchBank(data)
		{
			if (data == null) {
				this.newInvoiceItem.id_bank = "";
				this.newBanklabel = "";
				this.$forceUpdate();
				return;
			}
			this.newInvoiceItem.id_bank = data.id;
			this.newBanklabel = data.nama;
			this.$forceUpdate();
		},
		smartSearchBankUpdate(data)
		{
			// console.log('name')
			if (data == null) {
				this.invoiceitems[this.selectedIdforEdit].id_bank = "";
				this.newBanklabel = "";
				this.$forceUpdate();
				return;
			}
			this.invoiceitems[this.selectedIdforEdit].id_bank = data.id;
			this.newBanklabel = data.nama;
			this.$forceUpdate();
		},

	}
}
</script>
<style>
#modal-detail-histories .modal-dialog {
	max-width: 90vw !important;
}
</style>
<style scoped>
.btn {
	padding: 2px 6px;
}

/* ::v-deep .modal.show .modal-dialog {
    transform: translate(0px, 10%);
}
::v-deep .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 10.5rem);
}*/
.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
	width: 50%;
}
</style>
